// sentinel filter value for images with no classes, follows the '-1' empty-value convention of CheckboxListDropdown
export const IMAGE_CLASS_NONE = '-1';

export const IMAGE_CLASSES: { value: string; label: string }[] = [
    { value: '11', label: '11000 - Olevat rakenteet ja rakennusosat' },
    { value: '12', label: '12000 - Pilaantuneen maa-alueen puhdistustarve ja -tavoitteet' },
    { value: '13', label: '13000 - Perustusrakenteet' },
    { value: '14', label: '14000 - Pohjarakenteet' },
    { value: '15', label: '15000 - Kallion tiivistys- ja lujitusrakenteet' },
    { value: '16', label: '16000 - Maaleikkaukset ja-kaivannot' },
    { value: '17', label: '17000 - Kallioleikkaukset, -kaivannot ja -tunnelit' },
    { value: '18', label: '18000 - Penkereet, maapadot ja täytöt' },
    { value: '21', label: '21000 - Päällysrakenteen osat ja radan alusrakennekerrokset' },
    { value: '22', label: '22000 - Reunatuet, kourut, askelmat ja eroosiosuojaukset' },
    { value: '23', label: '23000 - Kasvillisuusrakenteet' },
    { value: '24', label: '24000 - Ratojen päällysrakenteet' },
    { value: '25', label: '25000 - Raitioteiden päällysrakenteet' },
    { value: '26', label: '26000 - Liikunta- ja virkistyspaikkojen päällysrakenteet' },
    { value: '31', label: '31000 - Vesihuollon järjestelmät' },
    { value: '32', label: '32000 - Turvallisuusrakenteet ja ohjausjärjestelmät' },
    { value: '33', label: '33000 - Sähkö-, tele- ja konetekniset järjestelmät' },
    { value: '34', label: '34000 - Lämmön- ja kaasunsiirtojärjestelmät' },
    { value: '37', label: '37000 - Liikunta- ja virkistyspaikkojen järjestelmät' },
    { value: '41', label: '41000 - Erittelemättömät rakennustekniset rakennusosat' },
    { value: '42', label: '42000 - Sillat' },
    { value: '43', label: '43000 - Laiturit' },
    { value: '44', label: '44000 - Perustus- ja tukirakenteet' },
    { value: '45', label: '45000 - Ympäristörakenteet' },
    { value: '46', label: '46000 - Rakennelmat ja kalusteet' },
];
